/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Label_PortInputs */

const es_ab_label_port = /** @type {(inputs: Ab_Label_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puerto base`)
};

const gl_ab_label_port = /** @type {(inputs: Ab_Label_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porto base`)
};

const en_ab_label_port = /** @type {(inputs: Ab_Label_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home port`)
};

/**
* | output |
* | --- |
* | "Home port" |
*
* @param {Ab_Label_PortInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_label_port = /** @type {((inputs?: Ab_Label_PortInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Label_PortInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_label_port(inputs)
	if (locale === "en") return en_ab_label_port(inputs)
	return es_ab_label_port(inputs)
});